export default {
    'handle.drag.snap': 'Drag Snap',
    'handle.drag.snap.panel': 'Boundary Limit',
    'handle.watermark': 'Watermark',
    'handle.width&height': 'Width/Height',
    'handle.page.width': 'Page Width',
    'handle.page.height': 'Page Height',
    'handle.template.name': 'Template Name',
    'handle.please.template.name': 'Please Enter Template Name',
    'handle.formatter': 'Formatter',
    'handle.lock.edit': 'Lock Edit',
    'handle.border.radius': 'Border Radius',
    'handle.opacity': 'Opacity',
    'handle.rotate': 'Rotation Angle',
    'handle.content.type': 'Content Type',
    'handle.barCode.type': 'Barcode Type',
    'handle.barCode.value': 'Barcode Value',
    'handle.text.auto.height': 'Auto Height',
    'handle.line.break': 'Line Break',
    'handle.line.height': 'Line Height',
    'handle.line.width': 'Line Width',
    'handle.dotted.style': 'Dashed Style',
    'handle.padding': 'Padding',
    'handle.padding.top': 'Top Padding',
    'handle.padding.bottom': 'Bottom Padding',
    'handle.padding.left': 'Left Padding',
    'handle.padding.right': 'Right Padding',
    'handle.top': 'Top',
    'handle.bottom': 'Bottom',
    'handle.left': 'Left',
    'handle.right': 'Right',
    'handle.margin': 'Margin',
    'handle.margin.top': 'Top Margin',
    'handle.margin.bottom': 'Bottom Margin',
    'handle.margin.left': 'Left Margin',
    'handle.margin.right': 'Right Margin',
    'handle.fixed.position': 'Fixed Position',
    'handle.clear.canvas': 'Clear Canvas',
    'handle.print.strategy': 'Print Strategy',
    'handle.display.strategy': 'Display Strategy',
    'handle.height.attr': 'Height Attribute',
    'handle.table.page.head': 'Table Page Header',
    'handle.add.statistics.row': 'Add Statistics Row',
    'handle.column': 'Column',
    'handle.table.statistics.type': 'Statistics Type',
    'handle.table.every.page.statistics': 'Per-Page Statistics',
    'handle.table.all.table.statistics': 'Entire Table Statistics'
};
